module.exports = __webpack_public_path__ + "static/media/Logo_iZH_loading.2c37cf19.svg";